import clsx from 'clsx';
import Spinner from 'react-bootstrap/Spinner';

interface BaySpinnerProps {
	title?: string;
	hideTitle?: boolean;
	className?: string;
	variant?: string;
	textColor?: string;
	isEmptyLoading?: boolean;
	size?: number;
	borderWidth?: string;
}

const BaySpinner = ({
	title,
	hideTitle = false,
	className,
	variant,
	textColor,
	borderWidth = '3px',
	isEmptyLoading = false,
	size = 20,
}: BaySpinnerProps) => {
	const classes = clsx(['bay-spinner', className]);

	return (
		<div
			className={`d-flex align-items-center justify-content-center ${classes}`}
		>
			<Spinner
				animation="border"
				style={{ width: size, height: size, borderWidth }}
				variant={variant ? variant : 'secondary'}
			/>
			{!isEmptyLoading && !hideTitle && (
				<div className={`ms-2 ${textColor ? textColor : 'text-700'} fw-bold`}>
					{title ? title : 'Loading...'}
				</div>
			)}
		</div>
	);
};

export default BaySpinner;
